import { Component, ContentChild, Input, OnDestroy, OnInit } from '@angular/core';
import { MapComponent } from './map.component';
import { Overlay } from 'ol';
import { PanOptions } from 'ol/Overlay';
import { ContentComponent } from './content.component';
import { Positioning as OverlayPositioning } from 'ol/Overlay';
import { Coordinate } from 'ol/coordinate';

@Component({
  selector: 'aol-overlay',
  template: '<ng-content></ng-content>',
})
export class OverlayComponent implements OnInit, OnDestroy {
  componentType = 'overlay';
  instance: Overlay;
  element: HTMLElement;
  @ContentChild(ContentComponent, { static: true })
  content: ContentComponent;
  // @ViewChild(MyComponent, { static: false, read: ElementRef })
  // readonly content?: ElementRef<HTMLElement>

  @Input()
  id: number | string;
  @Input()
  offset: number[];
  @Input()
  position: Coordinate;
  @Input()
  positioning: OverlayPositioning;// | string;
  @Input()
  stopEvent: boolean;
  @Input()
  insertFirst: boolean;
  @Input()
  autoPan: boolean;
  @Input()
  autoPanAnimation: PanOptions;
  @Input()
  autoPanMargin: number;

  constructor(private map: MapComponent) { }

  ngOnInit() {
    if (this.content) {
      this.element = this.content.elementRef.nativeElement;
      this.instance = new Overlay(this);
      this.map.instance.addOverlay(this.instance);
    }
  }

  ngOnDestroy() {
    if (this.instance) {
      this.map.instance.removeOverlay(this.instance);
    }
  }
}
